import { useMarketDetail } from '../queries/useMarketDetail';
import { useEffect, useState } from 'react';
import { bridge, isNotNil, useAsyncEffect } from 'shared/src/utils';
import { useIsForegroundNow } from 'shared/src/hooks';

export const useIsFavoriteMarket = (marketId: number) => {
  const isForegroundNow = useIsForegroundNow();

  const { data: marketDetail } = useMarketDetail(marketId);

  const [isFavoriteMarket, setIsFavoriteMarket] = useState(
    isNotNil(marketDetail.market.favorite),
  );

  useAsyncEffect(async () => {
    if (isForegroundNow) {
      const localMarketLike = await bridge.getLocalMarketFavorite();

      if (isNotNil(localMarketLike)) {
        const localFavorite = localMarketLike[marketId];
        if (isNotNil(localFavorite)) {
          setIsFavoriteMarket(localFavorite);
        }
      }
    }
  }, [isForegroundNow]);

  useEffect(() => {
    if (marketDetail) {
      setIsFavoriteMarket(isNotNil(marketDetail.market.favorite));
    }
  }, [marketDetail]);

  return {
    isFavoriteMarket,
  };
};
